import { TableArtifactView } from "./TableArtifact";
import type { QueryResultArtifact, TableArtifact } from "./types";

export function QueryResultArtifactView({ artifact }: { artifact: QueryResultArtifact }) {
  const tableArt: TableArtifact = {
    type: "table",
    columns: artifact.schema,
    rows: artifact.sample,
    result_ref: artifact.result_ref,
  };
  return (
    <div className="artifact">
      <div>
        <strong>{artifact.row_count.toLocaleString()} rows</strong> · sample of{" "}
        {artifact.sample.length}
      </div>
      <TableArtifactView artifact={tableArt} />
    </div>
  );
}
